import { render, staticRenderFns } from "./ChangePasswordError.vue?vue&type=template&id=4780c2cd&"
import script from "./ChangePasswordError.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports